import { memo } from 'react';
import './PartJobLine.scss';
import PropTypes from 'prop-types';

import UnitBoxes from '../UnitBoxes/UnitBoxes';

const PartJobLine = ({
  nameLine,
  namePosition,
  numberLine,
  numberPosition,
  unitMeasurement,
  backgroundColorPosition,
  backgroundColorLine,
  backgroundUnitMeasurement,
  colorPostion,
  colorLine,
  colorUnitMeasurement,
  orderByPosition,
  lineBlockedBySap
}) => {
  const lineBlockedBySapStyle = lineBlockedBySap ? 'text-danger' : '';

  return (
    <div className="part-job-line">
      <div>
        <UnitBoxes backgroundColor={backgroundColorPosition} color={colorPostion}>
          P{numberPosition}
        </UnitBoxes>
        <UnitBoxes backgroundColor={backgroundColorLine} color={colorLine}>
          L{numberLine}
        </UnitBoxes>
      </div>
      <div className={`part-job-line-mid-column ${orderByPosition ? 'position' : ''}`}>
        <p className={lineBlockedBySapStyle}>{namePosition}</p>
        <p className={lineBlockedBySapStyle}>{nameLine}</p>
      </div>
      <div className="unit-boxes-container">
        <UnitBoxes backgroundColor={backgroundUnitMeasurement} color={colorUnitMeasurement}>
          UMR
        </UnitBoxes>
        <span className={lineBlockedBySapStyle}>{unitMeasurement}</span>
      </div>
    </div>
  );
};

export default memo(PartJobLine);

PartJobLine.propTypes = {
  nameLine: PropTypes.string.isRequired,
  namePosition: PropTypes.string.isRequired,
  numberLine: PropTypes.number.isRequired,
  numberPosition: PropTypes.number.isRequired,
  unitMeasurement: PropTypes.string.isRequired,
  backgroundColorPosition: PropTypes.string,
  backgroundColorLine: PropTypes.string,
  backgroundUnitMeasurement: PropTypes.string,
  colorPostion: PropTypes.string,
  colorLine: PropTypes.string,
  colorUnitMeasurement: PropTypes.string,
  orderByPosition: PropTypes.bool,
  lineBlockedBySap: PropTypes.bool.isRequired
};

PartJobLine.defaultProps = {
  backgroundColorPosition: '#FFF',
  backgroundColorLine: '#FFF',
  backgroundUnitMeasurement: '#FFF',
  colorPostion: '#000',
  colorLine: '#000',
  colorUnitMeasurement: '#000',
  orderByPosition: false
};
